
const ProofSection = () => {
  return (
    <section className="py-32 bg-black relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-4 block">
              OUR PHILOSOPHY
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-8">
              Results Over <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Hype</span>
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-8">
              CruxOnAI prioritizes durable improvements — not flashy demos. Systems are judged by reliability, adoption, and measurable performance.
            </p>
            
            <div className="space-y-4">
              {['Reliability-first approach', 'High adoption rates', 'Measurable performance metrics'].map((item, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/10 rounded-lg">
                    <i className="ri-check-double-line text-emerald-400 text-xl"></i>
                  </div>
                  <span className="text-white font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-zinc-800">
              <img
                src="https://public.readdy.ai/ai/img_res/5d53ed842c5278043407ddb28bd62ef6.jpg"
                alt="Results Dashboard"
                className="w-full h-96 object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProofSection;
